/** Logical index → track position (reversed strip in FA). */
export function learnerImageCarouselVisualIndex(
  currentImageIndex: number,
  slideCount: number,
  isRtl: boolean,
): number {
  return isRtl ? slideCount - 1 - currentImageIndex : currentImageIndex;
}

/**
 * EN: slides [0…n] L→R; index 0 at translate 0.
 * FA: reversed track [n…0]; index 0 starts at visual position n−1 (e.g. slide 3 of 3).
 */
export function learnerImageCarouselTrackTransform(
  currentImageIndex: number,
  slideCount: number,
  dragOffsetPx: number,
  isRtl: boolean,
): string {
  const slidePercent = 100 / slideCount;
  const visualIndex = learnerImageCarouselVisualIndex(currentImageIndex, slideCount, isRtl);
  return `translateX(calc(-${visualIndex * slidePercent}% + ${dragOffsetPx}px))`;
}

export function learnerImageCarouselPrevButtonSide(isRtl: boolean): 'left-2' | 'right-2' {
  return isRtl ? 'right-2' : 'left-2';
}

export function learnerImageCarouselNextButtonSide(isRtl: boolean): 'left-2' | 'right-2' {
  return isRtl ? 'left-2' : 'right-2';
}

/** EN: swipe left → next. FA (reversed track): swipe right → next. */
export function learnerImageCarouselSwipeAction(
  dragOffsetPx: number,
  isRtl: boolean,
  threshold = 48,
): 'next' | 'prev' | null {
  if (isRtl) {
    if (dragOffsetPx > threshold) return 'next';
    if (dragOffsetPx < -threshold) return 'prev';
  } else {
    if (dragOffsetPx < -threshold) return 'next';
    if (dragOffsetPx > threshold) return 'prev';
  }
  return null;
}

/** Track slide order: reversed in FA so the next image sits left of the current one. */
export function learnerImageCarouselTrackUrls<T>(urls: T[], isRtl: boolean): T[] {
  return isRtl ? [...urls].reverse() : urls;
}

/** Map track render index back to the logical image index (pagination, aspect ratios). */
export function learnerImageCarouselLogicalIndex(
  trackIndex: number,
  slideCount: number,
  isRtl: boolean,
): number {
  return isRtl ? slideCount - 1 - trackIndex : trackIndex;
}
